import React from 'react';
import {
  Drawer, Col, Row, Typography, Divider,
} from 'antd';
import _ from 'lodash';

const { Paragraph, Text } = Typography;

const DescrtiptionItem = ({ title, value, showValue = !!value }) => (
  <Paragraph>
    {title && <Text className="lightFont">{`${title} `}</Text>}
    <div>
      {showValue
        ? <Text className="darkFont">{value}</Text>
        : <Text className="darkFont" type="secondary">Not Provided</Text>}
    </div>
  </Paragraph>
);

const drawerTitle = (result) => {
  if (!result || _.isEmpty(result)) return undefined;
  return (
    <Row>
      <Col span={16}>
        <DescrtiptionItem value={result.centre_name} />
        <div className="fw500">
          Booking #{result.booking_id}
        </div>
      </Col>
    </Row>
  )
};

const DetailDescriptionModal = ({
  data = {},
  columnData,
  result,
  visible,
  onSubmit,
  onCancel,
  title,
  submitText,
  footer,
  ...props
}) => {
  console.log('columnData', data.view_details)
  return (
    <Drawer
      title={drawerTitle(data.view_details)}
      placement="right"
      onClose={onCancel}
      visible={visible}
      onCancel={onCancel}
      // destroyOnClose
      width={500}
      {...props}
    >
      {
        data.view_details
          ? (
            <>
              <Row>
                <Col span={24} className="fw500 mb-10">
                  <Text>Booking Summary</Text>
                </Col>
                <Col span={12}>
                  <DescrtiptionItem title="Booking Date" value={data.view_details.booking_date} />

                </Col>
                <Col span={12} className='right-align-col'>
                  <DescrtiptionItem title="Booking Status" value={data.view_details.status} />
                </Col>
                <Col span={24}>
                  <DescrtiptionItem title="Emergency Type" value={data.view_details.emergency_type} />
                </Col>
                <Col span={24}>
                  <DescrtiptionItem title="Emergency Description" value={data.view_details.emergency_notes} />
                </Col>
                <Col span={24} className="lightFont">
                  <Text className="lightFont">Patient Name</Text>
                </Col>
                <Col span={12} className="mb-10">
                  <Text>{data.view_details.patient_name} <br />
                    {data.view_details.patient_age}, {data.view_details.patient_gender}</Text>
                </Col>
                <Col span={24}>
                  <DescrtiptionItem title="Patient Address" value={data.view_details.address} />
                </Col>
              </Row>
              <Divider />
              <Row>
                <Col span={24} className="fw500 mb-10">
                  <Text>Health Centre Details</Text>
                </Col>

                <Col span={24} className="lightFont">
                  <Text className="lightFont">Health Centre</Text>
                </Col>
                <Col span={12} className="mb-10">
                  <Text>{data.view_details.centre_name} <br />
                    {data.view_details.centre_speciality}</Text>
                </Col>
                <Col span={24}>
                  <DescrtiptionItem title="Centre location" value={data.view_details.centre_address} />
                </Col>
              </Row>
            </>
          ) : null
      }
    </Drawer>
  );
};

export default DetailDescriptionModal;
